export default function Container({ children }) {
	return <div className="container mx-auto" data-sentry-component="Container" data-sentry-source-file="index.jsx">{children}</div>;
}
